<script setup>
// Aviso de pendência de pagamento na Meta (erro 131042) da caixa WhatsApp:
// os templates (fora da janela de 24h) estão sendo recusados. A marca vem do
// backend (`inbox.meta_payment_issue`) e some sozinha quando um template é
// entregue. Quem usa decide quando mostrar (ver `showMetaPaymentIssue`).
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';

const { t } = useI18n();
</script>

<template>
  <div
    role="alert"
    class="flex items-start gap-2 px-4 py-2 text-xs border-b bg-n-amber-2 text-n-amber-11 border-n-amber-6"
  >
    <Icon icon="i-lucide-credit-card" class="size-4 shrink-0 mt-px" />
    <span>{{ t('CONVERSATION.META_PAYMENT_ISSUE_BANNER.MESSAGE') }}</span>
  </div>
</template>
